// UNIT
// Phase E Cycle 7 — values sourced from the canonical BE enums.
import {
  SubscriptionDurationType,
  SubscriptionLimitType,
  SubscriptionStatus
} from 'types/api/subscriptions';

export const SUBSCRIPTION_UNIT_WEEK = 1;
export const SUBSCRIPTION_UNIT_MONTH = 2;
export const SUBSCRIPTION_UNIT_PERCENT = 3;
export const SUBSCRIPTION_UNIT_GB = 4;
export const SUBSCRIPTION_UNIT_HAS_ACCESS = 5;
export const SUBSCRIPTION_UNIT_NO_ACCESS = 6;

export const UNIT_OPTIONS = {
  week: SUBSCRIPTION_UNIT_WEEK,
  month: SUBSCRIPTION_UNIT_MONTH,
  percent: SUBSCRIPTION_UNIT_PERCENT,
  gb: SUBSCRIPTION_UNIT_GB,
  has_access: SUBSCRIPTION_UNIT_HAS_ACCESS,
  no_access: SUBSCRIPTION_UNIT_NO_ACCESS
} as const;

export const UNIT_OPTIONS_VALUES = {
  [SUBSCRIPTION_UNIT_WEEK]: 'week',
  [SUBSCRIPTION_UNIT_MONTH]: 'month',
  [SUBSCRIPTION_UNIT_PERCENT]: 'percent',
  [SUBSCRIPTION_UNIT_GB]: 'gb',
  [SUBSCRIPTION_UNIT_HAS_ACCESS]: 'has_access',
  [SUBSCRIPTION_UNIT_NO_ACCESS]: 'no_access'
} as const;

export const UNIT_OPTIONS_DATA = [
  {
    label: 'week',
    value: UNIT_OPTIONS.week
  },
  {
    label: 'month',
    value: UNIT_OPTIONS.month
  },
  {
    label: 'percent',
    value: UNIT_OPTIONS.percent
  },
  {
    label: 'gb',
    value: UNIT_OPTIONS.gb
  },
  {
    label: 'has_access',
    value: UNIT_OPTIONS.has_access
  },
  {
    label: 'no_access',
    value: UNIT_OPTIONS.no_access
  }
];

// LIMIT
export const SUBSCRIPTION_LIMIT_LIMITED = SubscriptionLimitType.Limited;
export const SUBSCRIPTION_LIMIT_UNLIMITED = SubscriptionLimitType.Unlimited;

export const SUBSCRIPTION_LIMIT_OPTIONS = {
  limited: SubscriptionLimitType.Limited,
  unlimited: SubscriptionLimitType.Unlimited
} as const satisfies Record<string, SubscriptionLimitType>;

export const SUBSCRIPTION_LIMIT_OPTIONS_VALUES = {
  [SubscriptionLimitType.Limited]: 'limited',
  [SubscriptionLimitType.Unlimited]: 'unlimited'
} as const satisfies Record<SubscriptionLimitType, string>;

// DURATION
export const SUBSCRIPTION_MONTHLY_DURATION = SubscriptionDurationType.Month;
export const SUBSCRIPTION_YEARLY_DURATION = SubscriptionDurationType.Year;
export const SUBSCRIPTION_FREE_DURATION = SubscriptionDurationType.Free;

export const DURATION_TYPE = {
  month: SubscriptionDurationType.Month,
  year: SubscriptionDurationType.Year,
  free: SubscriptionDurationType.Free
} as const satisfies Record<string, SubscriptionDurationType>;

export const DURATION_TYPE_VALUES = {
  [SubscriptionDurationType.Month]: 'month',
  [SubscriptionDurationType.Year]: 'year',
  [SubscriptionDurationType.Free]: 'free'
} as const satisfies Record<SubscriptionDurationType, string>;

export const DURATION_TYPE_DATA: Array<{
  label: string;
  value: SubscriptionDurationType;
}> = [
  { label: 'monthly', value: SubscriptionDurationType.Month },
  { label: 'yearly', value: SubscriptionDurationType.Year },
  { label: 'free', value: SubscriptionDurationType.Free }
];

export const LIMIT_TYPE_DATA: Array<{
  label: string;
  value: SubscriptionLimitType;
}> = [
  { label: 'limited', value: SubscriptionLimitType.Limited },
  { label: 'unlimited', value: SubscriptionLimitType.Unlimited }
];

// STATUS
export const SUBSCRIPTION_ACTIVE_STATUS = SubscriptionStatus.Active;
export const SUBSCRIPTION_INACTIVE_STATUS = SubscriptionStatus.Inactive;
export const SUBSCRIPTION_ARCHIVED_STATUS = SubscriptionStatus.Archived;

export const SUBSCRIPTION_STATUSES = {
  active: SubscriptionStatus.Active,
  inactive: SubscriptionStatus.Inactive,
  archived: SubscriptionStatus.Archived
} as const satisfies Record<string, SubscriptionStatus>;

export const SUBSCRIPTION_STATUS_VALUES = {
  [SubscriptionStatus.Active]: 'active',
  [SubscriptionStatus.Inactive]: 'inactive',
  [SubscriptionStatus.Archived]: 'archived'
} as const satisfies Record<SubscriptionStatus, string>;
